import axios from 'axios'
import { domains } from './config'

const documentApiAddress = `${domains.DOCUMENT_APP_DOMAIN}`

const documentServiceApi = (() => {
  const _api = axios.create({
    baseURL: documentApiAddress,
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
  })

  let authInstance

  _api.interceptors.request.use(async request => {
    const token = await authInstance.getAccessTokenSilently()
    request.headers.Authorization = `Bearer ${token}`
    request.data.auth = token
    return request
  })

  _api.interceptors.response.use(
    response => {
      return response
    },

    error => {
      if (error.response.status === 401) {
        location.replace(window.location.origin)
      }
      return Promise.reject(error)
    },
  )

  return {
    setAuthInstance: async newAuthInstance => {
      authInstance = newAuthInstance
    },
    post: _api.post,
  }
})()

export default documentServiceApi
